export default (url) => {
    return `${url}`.replace(/(https?:\/\/)|(\/)+/g, "$1$2")
}